// v235.1.0 — Single source for the "authorization required" routing signal.
//
// Primary signal: the Stedi 271 (profiles.insurance.last_eligibility) —
// priorAuthRequired and planType. Fallback: a plan-name string heuristic
// (mirrors the MD-side waitingRoomReadiness.isHMOPlan logic) for when the
// 271 is silent or absent. Per product: HMO is treated as auth-required by
// default.

const HMO_PATTERNS = [/\bHMO\b/i, /\bEPO\b/i, /Health Plan/i, /Medicare Advantage HMO/i, /Medicaid HMO/i]
const PPO_PATTERNS = [/\bPPO\b/i, /Original Medicare/i, /Self.?pay/i]

export function isHMOInsurance(insurance) {
  if (!insurance) return false
  // ProfileInsurance writes coverageType: 'hmo' as the canonical structured
  // field. Plan name string is a fallback for older records.
  if ((insurance.coverageType || '').toLowerCase() === 'hmo') return true
  if ((insurance.planType || '').toLowerCase() === 'hmo') return true
  const planString = `${insurance.provider || insurance.insurerName || ''} ${insurance.plan || insurance.planType || ''}`.trim()
  if (!planString) return false
  for (const pat of PPO_PATTERNS) if (pat.test(planString)) return false
  for (const pat of HMO_PATTERNS) if (pat.test(planString)) return true
  return false
}

// eligibility = parsed 271 shape from profiles.insurance.last_eligibility
export function deriveAuthRequired(insurance, eligibility) {
  if (eligibility) {
    if (eligibility.priorAuthRequired === true) return true
    if ((eligibility.planType || '').toUpperCase() === 'HMO') return true
    if (eligibility.priorAuthRequired === false) return false
  }
  return isHMOInsurance(insurance)
}
